import * as React from 'react';
import { DialogStateContext } from './dialog-state';
import { DialogControlContext } from './dialog-control';
/**
 *
 * @param id the unique ID you would like to associate with this dialog
 * @param dialogQueryKey optional unique key in query parameter you would like to use in url with dialog pop up
 * @param isDismissable optional boolean to determine if the dialog can be closed when clicking on the Layer
 * @param onDismissCB optional callback function to be executed upon closing the dialog via closeDialog()
 * @returns [isOpen, dialogActions, DialogComponent]
 */
export var useDialog = function (id, dialogQueryKey, isDismissable, onDismissCB) {
    if (dialogQueryKey === void 0) { dialogQueryKey = 'pwaDialog'; }
    if (isDismissable === void 0) { isDismissable = true; }
    var _a = React.useContext(DialogStateContext), openedDialogs = _a.openedDialogs, open = _a.open, close = _a.close;
    var useDialogControl = React.useContext(DialogControlContext).useDialogControl;
    var dialogId = "".concat(id, "_").concat(dialogQueryKey);
    var isOpen = openedDialogs.includes(dialogId);
    var setIsOpen = React.useCallback(function (isOpen, closeAllDialogs) {
        if (closeAllDialogs) {
            openedDialogs.forEach(function (dialog) {
                close(dialog);
            });
        }
        if (isOpen) {
            open(dialogId);
        }
        else if (!isOpen && !closeAllDialogs) {
            close(dialogId);
        }
    }, [open, close, dialogId, openedDialogs]);
    var _b = useDialogControl(id, dialogQueryKey, isOpen, setIsOpen, isDismissable, onDismissCB), actions = _b.actions, ComponentFactory = _b.ComponentFactory;
    return [isOpen, actions, ComponentFactory];
};
//# sourceMappingURL=use-dialog.js.map